import React from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import styled from 'styled-components';

type Arrow = {
  onClick: () => void;
  disabled: boolean;
};

const StyledArrow = styled.div<{ disabled: boolean }>`
  color: ${(props) => (props.disabled ? props.theme.colors.grey.light : props.theme.colors.common.black)};
  font-size: 2rem;
  font-weight: bold;
  padding: 14px;
  cursor: pointer;
`;

export const NextArrow = (props: Arrow) => {
  const { onClick, disabled } = props;
  return (
    <StyledArrow
      onClick={() => {
        if (!disabled) {
          onClick();
        }
      }}
      disabled={disabled}
    >
      <RightOutlined />
    </StyledArrow>
  );
};

export const PrevArrow = (props: Arrow) => {
  const { onClick, disabled } = props;
  return (
    <StyledArrow
      onClick={() => {
        if (!disabled) {
          onClick();
        }
      }}
      disabled={disabled}
    >
      <LeftOutlined />
    </StyledArrow>
  );
};
